export default __webpack_public_path__ + "static/media/19.ab8b627a.png";